module.exports = __webpack_public_path__ + "static/media/16.6cad1508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/16.jpg
// module id = 549
// module chunks = 0